import { types } from 'mobx-state-tree';
import Base from 'model/stores/base';

const SignInStore = types.model({
  service_url: '/v2/login/tokens',
  data: types.maybeNull(types.frozen()),
  error: types.optional(types.boolean, false)
}).actions(self => ({
  loadPage() {
    self.data = null;
    self.loading = true;
    self.error = false;

    return self.load(self.service_url, {}, 'GET', self.loadSuccess, self.loadFailure)
      .catch(self.loadFailure);
  },

  loadSuccess(response) {
    if (!response.result || !response.result.csrf_token) {
      self.loadFailure();
      return;
    }

    self.data = response.result;
    self.loading = false;
  },

  loadFailure() {
    self.error = true;
    self.loading = false;
  }
}));

export default types.compose('SignInStore', Base, SignInStore);
